import { render, staticRenderFns } from "./UserDataPage.vue?vue&type=template&id=41d05a89&"
import script from "./UserDataPage.vue?vue&type=script&lang=js&"
export * from "./UserDataPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports